import { getLocale } from '../i18n';

export function formatEventDate(eventAt) {
  if (!eventAt) return '';
  return new Date(eventAt).toLocaleDateString(getLocale(), {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function normalizeCompetitionList(data) {
  const rawList = Array.isArray(data) ? data : data?.content ?? data?.data ?? [];

  return rawList
    .filter((item) => item?.id != null && item?.name)
    .map((item) => {
      const eventDate = formatEventDate(item.eventAt);
      const tagParts = [item.location, eventDate].filter(Boolean);

      return {
        id: Number(item.id),
        value: String(item.id),
        code: String(item.id),
        name: item.name,
        location: item.location ?? '',
        eventAt: item.eventAt,
        competitionType: item.competitionType,
        division: item.division,
        tag: tagParts.join(' · '),
      };
    });
}
